import { Box, Typography, Paper, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions, Button, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import SmartToyIcon from '@mui/icons-material/SmartToy';
import BusinessIcon from '@mui/icons-material/Business';
import CategoryIcon from '@mui/icons-material/Category';
import Agente from "./Agente";
import ContextoProduto from "../Gestao/ContextoProduto";
import ContextoInstitucional from "../Gestao/ContextoInstitucional";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Check, Copy } from "lucide-react";

import SecInfoHistorico from "../Gestao/SecInfoHistorico";
import RestoreIcon from '@mui/icons-material/Restore';
import SecurityIcon from '@mui/icons-material/Security';

import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';

import Parametros from "./Parametros";

const SDRConfig = ({ produto = 'AC' }) => {
    const [contextoProduto,] = useState('');
    const [, setAtualizaContexto] = useState(true);
    const [deveUpdateContexto, setDeveUpdateContexto] = useState(false);
    const [tabAtiva, setTabAtiva] = useState(0);
    const [mostrarExemplo, setMostrarExemplo] = useState(false);
    const [copied, setCopied] = useState(false);

    const text = `Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081Sobre a Aipim Minha Casa Minha Vida
A Aipim Incorporadora foi fundada em 2023, por sócios com amplo conhecimento e experiência técnica na gestão e desenvolvimento de empreendimentos imobiliários. Desde da sua fundação, a Aipim Incorporadora já entregou 120 unidades habitacionais e nos próximos 2 anos entregará mais 260 unidades, relativas aos empreendimentos. Além disso, os 4 lançamentos previstos para os próximos 3 anos, totalizam outras 240 unidades habitacionais.

Contato da Empresa
Os contatos da Aipim são os telefones +55 (24) 98827-0250 e +55 (11) 91744-2081`;

    const textProduto = `O Solar do Grajaú é um empreendimento moderno e com um preço diferenciado.  Esse lançamento da AIPIM Incorporadora possui 2 quartos e é muito bem localizado no Grajaú próximo muito comércio, e irá contar com lazer completo.  Sob os benefícios do Programa Minha Casa Minha Vida, este empreendimento terá condições especiais de financiamento, e será uma ótima oportunidade para sair do aluguel!  Se o cliente desejar saber mais sobre o projeto, fale sempre que o consultor vai poder ajudar ele com as informações que ele precisa e tente qualificar para enviar.  Mas caso ele insista em saber mais, envie o video do empreendimento: https://youtu.be/IV97C-KFBUU?si=oDzIwUOAk6CdEePV    Observações Solar do Grajaú:  A renda mínima para o Solar do Grajaú é de R$3.400,00.(nunca passe essa informação para o cliente)  O Solar do Grajaú possui unidades com preço a partir de R$220.273,00    - A Região do Solar do Grajáu:  Próximo a UBS Chácara do Sol (2 min de carro e 10 min andando)   Supermercados Boizão (5 min de carro e 30 min andando)   Ayumi Supermercado (5 min de carro e 30 min andando)   Paróquia Nossa Senhora do Carmo  (5 min de carro e 30 andando)    -Localização:  Endereço do Stand: Av. Miguel Yunes, 351  Endereço do Empreendimento: Estrada do Schmidt, 74 - Grajaú, São Paulo - SP    -Informações Técnicas:  🏠 2 dormitórios;  📏 38 a 78m²;  🏡 Sacada;  🚗 1 vaga de garagem.    -Área de lazer Comum:  💪 Academia;  🍻 Espaço Bar;  🎠 Brinquedoteca;  🍖 Churrasqueira;  💼 Coworking;  🧘‍♀️ Espaço Bem Estar;  📦 Espaço Delivery;  🏋️‍♂️ Espaço Fitness;  🍔 Food Park;  🛒 Market;  🐕 Pet Care;  🐾 Pet Place;  🏊‍♂️ Piscina;  🛝 Playground;  🎉 Salão de Festas;  🌅 Terraço;`;

    function getNomeProduto(produto) {
        switch (produto) {
            case 'AC':
                return {
                    produtoRetorno: "Agente de Conteúdo",
                    pessoaRespondida: "Usuários"
                };
            case "sdr":
                return {
                    produtoRetorno: "Agente de Pr\u00e9-Venda",
                    produtoLabel: "Agente de Pr\u00e9 Venda",
                    pessoaRespondida: "Leads"
                };
            default:
                return {
                    produtoRetorno: "Seu Agente",
                    produtoLabel: "Seu Agente",
                    pessoaRespondida: "Usuários"
                };
        }
    }

    const { produtoRetorno, produtoLabel = produtoRetorno, pessoaRespondida } = getNomeProduto(produto);

    useEffect(() => {
        if (deveUpdateContexto) {
            setAtualizaContexto(true);
            setDeveUpdateContexto(false);
        }
    }, [deveUpdateContexto]);

    const handleTabChange = (event, novaTab) => {
        setTabAtiva(novaTab);
    };

    const handleCopy = () => {
        const textToCopy = tabAtiva === 1 ? text : textProduto;
        navigator.clipboard.writeText(textToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const getTabDescription = (tabIndex) => {
        switch (tabIndex) {
            case 0:
                return "Informações gerais do Agente";
            case 1:
                return "Defina informações sobre sua empresa";
            case 2:
                return "Configure os seus produtos";
            case 3:
                return "Configure os parâmetros do seu Agente no CRM";
            case 4:
                return "Visualize o histórico de alterações do produto"
            default:
                return "";
        }
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
            {/* Seção Informativa */}
            <Paper
                elevation={1}
                sx={{
                    p: { xs: 2, sm: 2.5 },
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                    backgroundColor: 'background.paper'
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Tooltip title="Acesso restrito a administradores" arrow placement="top"
                        slotProps={{
                                                tooltip: {
                                                    sx: {
                                                        fontSize: 16, // tamanho da fonte do tooltip
                                                        maxWidth: 250,
                                                    },
                                                },
                                            }}
                    >
                        <SecurityIcon sx={{ mr: 1, fontSize: '18px', color: 'primary.main', cursor: 'help' }} />
                    </Tooltip>
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'text.secondary',
                            lineHeight: 1.5,
                            fontSize: '0.9rem'
                        }}
                    >
                        Configure as informações do {produtoLabel}. Alterações afetam diretamente como seu Agente responde aos seus {pessoaRespondida}.
                    </Typography>
                </Box>
            </Paper>

            {/* Tabs de Contextos */}
            <Paper elevation={1} sx={{ borderRadius: 2, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', overflow: 'hidden' }}>
                <Tabs
                    value={tabAtiva}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontSize: { xs: '0.8rem', sm: '0.9rem' },
                            fontWeight: 500,
                            minWidth: { xs: 100, sm: 140 },
                            py: 2,
                            '& .MuiTab-iconWrapper': {
                                marginBottom: '4px !important'
                            }
                        }
                    }}
                >
                    <Tab
                        icon={<SmartToyIcon sx={{ fontSize: '18px' }} />}
                        label="Agente"
                    />
                    <Tab
                        icon={<BusinessIcon sx={{ fontSize: '18px' }} />}
                        label="Informações Institucionais"
                    />
                    <Tab
                        icon={<CategoryIcon sx={{ fontSize: '18px' }} />}
                        label="Informações do Produto"
                    />
                    <Tab
                        icon={<TuneOutlinedIcon sx={{ fontSize: '18px' }} />}
                        label="Parâmetros"
                    />
                    <Tab
                        icon={<RestoreIcon sx={{ fontSize: '18px' }} />}
                        label="Histórico de Alterações"
                    />
                </Tabs>

                {/* Descrição da tab ativa */}
                <Box sx={{
                    px: 3,
                    py: 1.5,
                    backgroundColor: 'action.hover',
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    display: 'block'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.primary',
                                fontSize: '0.85rem',
                                fontStyle: 'italic',
                                fontWeight: 'bold',
                            }}
                        >
                            {getTabDescription(tabAtiva)}
                        </Typography>
                    </Box>

                    {/* Modal de Exemplo */}
                    <Dialog
                        open={mostrarExemplo}
                        onClose={() => setMostrarExemplo(false)}
                        maxWidth="md"
                        fullWidth
                        PaperProps={{
                            sx: { borderRadius: 2 }
                        }}
                    >
                        <DialogTitle sx={{
                            backgroundColor: '#1976d2',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                        }}>
                            <HelpOutlineIcon />
                            {tabAtiva === 1 ? 'Exemplo de Informações Institucionais' : 'Exemplo de Informações do Produto'}
                        </DialogTitle>

                        <DialogContent sx={{ mt: 2 }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    mb: 2,
                                    color: 'text.secondary',
                                    fontWeight: 500
                                }}
                            >
                                {`Use este exemplo como referência para preencher as ${tabAtiva === 1 ? "informações da sua empresa" : "informações dos seus produtos"}:`}
                            </Typography>

                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    backgroundColor: 'background.default',
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                    position: 'relative',
                                    maxHeight: '400px',
                                    overflow: 'auto'
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        whiteSpace: 'pre-line',
                                        fontSize: '0.85rem',
                                        color: 'text.primary',
                                        fontFamily: 'monospace',
                                        lineHeight: 1.6,
                                        mb: 1
                                    }}
                                >
                                    {tabAtiva === 1 ? text : textProduto}
                                </Typography>
                            </Paper>
                        </DialogContent>

                        <DialogActions sx={{ p: 2, gap: 1 }}>
                            <Button
                                onClick={handleCopy}
                                variant="outlined"
                                startIcon={copied ? <Check size={16} /> : <Copy size={16} />}
                                sx={{
                                    textTransform: 'none',
                                    color: copied ? '#10a37f' : '#1976d2',
                                    borderColor: copied ? '#10a37f' : '#1976d2'
                                }}
                            >
                                {copied ? 'Copiado!' : 'Copiar exemplo'}
                            </Button>
                            <Button
                                onClick={() => setMostrarExemplo(false)}
                                variant="contained"
                                sx={{ textTransform: 'none' }}
                            >
                                Fechar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>

                <Box sx={{ p: 3, bgcolor: 'background.paper', color: 'text.primary', overflowX: 'hidden' }}>
                    {/* Tab Agente */}
                    {tabAtiva === 0 && (
                        <Agente />
                    )}

                    {/* Tab Contexto Institucional */}
                    {tabAtiva === 1 && (
                        <ContextoInstitucional
                            nomeContexto="contextoInstitucional"
                            setDeveUpdateContexto={setDeveUpdateContexto}
                            produto={produto}
                            nomeExibicao="Informações Institucionais"
                        />
                    )}

                    {/* Tab Contexto Produto */}
                    {tabAtiva === 2 && (
                        <ContextoProduto
                            nomeContexto="contextoProduto"
                            conteudoContexto={contextoProduto}
                            setDeveUpdateContexto={setDeveUpdateContexto}
                            produto={produto}
                            nomeExibicao="Informações do Produto "
                        />
                    )}

                    {/* Tab Contexto Produto */}
                    {tabAtiva === 3 && (
                        <Parametros />
                    )}

                    {/* Tab Histórico de Justificativas */}
                    {tabAtiva === 4 && (
                        <SecInfoHistorico
                            produtoRetorno={produtoRetorno}
                            pessoaRespondida={pessoaRespondida}
                        />
                    )}
                </Box>
            </Paper>
        </Box>
    );
};

export default SDRConfig;
